export enum Route {
    DASHBOARD = "dashboard",
    // PROJECT = "project", // currently same as dashboard
    // CREATE_PROJECT = "project/create",
    // EDIT_PROJECT = "project/edit",
    // REPORTS = "reports",
    // DOWNLOADS = "downloads",
    // STIMULI = "stimuli",
    SIGNIN = "signin",
    ISP_WRAPPERS = "isp-wrappers",
    SIGNUP = "signup",
    FORGOT_PASSWORD = "forgot-password",
    RESET_PASSWORD = "reset-password",
    AUTH = "auth",
    // PROJECT_ANALYSIS = "project/analysis",
    PROFILE = "profile",
    // TESTER = "live-monitoring/participate",
    // INTEGRATION = "integrate/platform",
    INSIGHTS_CUBE = "insights-cube",
    INSIGHTS_CUBE_DIR = "directory",
    ASK_INSIGHT_PRO = "ask-insight-pro"
}